import apiService from './api';
import { Employee, CreateEmployeeData, UpdateEmployeeData, EmployeePermissions } from '../types/employeeTypes';

class EmployeeService {
  async getEmployees(): Promise<Employee> {
    const response = await apiService.get<Employee>('/employees');
    console.log("response:::::;", response.data);
    return response.data
  }

  async getEmployee(id: string): Promise<Employee> {
    const response = await apiService.get<Employee>(`/employees/${id}`);
    return response.data;
  }

  async createEmployee(data: CreateEmployeeData): Promise<Employee> {
    const response = await apiService.post<Employee>('/employees', data);
    return response.data;
  }

  async updateEmployee(data: UpdateEmployeeData): Promise<Employee> {
    const response = await apiService.put<Employee>(`/employees/${data.id}`, data);
    return response.data;
  }

  async deleteEmployee(id: string): Promise<void> {
    await apiService.delete(`/employees/${id}`);
  }

  async toggleEmployeeStatus(id: string): Promise<Employee> {
    const response = await apiService.patch<Employee>(`/employees/${id}/toggle-status`);
    return response.data;
  }

  async updateEmployeePermissions(id: string, permissions: any): Promise<Employee> {
    const response = await apiService.patch<Employee>(`/employees/${id}/permissions`, { permissions });
    return response.data;
  }

  async getActiveEmployees(): Promise<Employee[]> {
    const response = await apiService.get<Employee[]>('/employees/active');
    return response.data;
  }

  async viewEmployeeDetails(id: string): Promise<{ password: string; email: string }> {
    const response = await apiService.get<{ password: string; email: string }>(`/employees/${id}/viewDetails`);
    return response.data;
  }

  async getEmployeePermissions(id: string): Promise<any> {
    const response = await apiService.get<EmployeePermissions>(`/employees/${id}/permissions`);
    return response.data;
  }
}

export const employeeService = new EmployeeService();
export default employeeService; 